import Select, { type SelectProps } from './Select';
export type { SelectProps };

export default Select;
